import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';
import { LOGO } from '../data/assets';
import { getCategories, getSettings } from '../lib/api';

const Footer = () => {
  const [cats, setCats] = useState([]);
  const [settings, setSettings] = useState({});
  useEffect(() => {
    getCategories().then(setCats).catch(() => {});
    getSettings().then(setSettings).catch(() => {});
  }, []);

  return (
    <footer className="bg-[#0b3d1e] text-gray-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="bg-white inline-block rounded-lg p-3 mb-4">
            <img src={LOGO} alt="National Light" className="h-12 w-auto" />
          </div>
          <p className="text-sm text-gray-300 leading-relaxed">Premium LED lighting solutions for homes, offices, commercial and industrial spaces. Brighter lights, better tomorrow.</p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Instagram, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#37b34a] flex items-center justify-center transition-colors"><Icon size={17} /></a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-lg">Categories</h4>
          <ul className="space-y-2.5 text-sm">
            {cats.map(c => (
              <li key={c.slug}><Link to={`/shop?category=${encodeURIComponent(c.name)}`} className="text-gray-300 hover:text-[#8bc34a] transition-colors">{c.name}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-lg">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="text-gray-300 hover:text-[#8bc34a] transition-colors">About Us</Link></li>
            <li><Link to="/manufacturing" className="text-gray-300 hover:text-[#8bc34a] transition-colors">Manufacturing</Link></li>
            <li><Link to="/shop" className="text-gray-300 hover:text-[#8bc34a] transition-colors">All Products</Link></li>
            <li><Link to="/contact" className="text-gray-300 hover:text-[#8bc34a] transition-colors">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-lg">Get In Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5"><Phone size={17} className="text-[#8bc34a] mt-0.5" /> {settings.phone || '+92 300 1234567'}</li>
            <li className="flex items-start gap-2.5"><Mail size={17} className="text-[#8bc34a] mt-0.5" /> {settings.email || 'info@nationallight.pk'}</li>
            <li className="flex items-start gap-2.5"><MapPin size={17} className="text-[#8bc34a] mt-0.5" /> {settings.address || 'Lahore, Pakistan'}</li>
          </ul>
          <div className="mt-5 flex flex-wrap gap-x-4 gap-y-1 text-xs">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-[#8bc34a]">Privacy Policy</Link>
            <Link to="/refund-policy" className="text-gray-400 hover:text-[#8bc34a]">Refund Policy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-[#8bc34a]">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 text-center text-sm text-gray-400">
          © {new Date().getFullYear()} National Light. All rights reserved. — We Bright The Nation.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
